"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var factorySvgIcon_1 = __importDefault(require("./utils/factorySvgIcon"));
var SvgLike = function (props) {
    var color = props.color;
    return (React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.4326 5.60655L15.2359 8H20C21.1046 8 22 8.89543 22 10V14.018C22 14.4495 21.9069 14.8758 21.7272 15.268L19.4438 20.25C18.9551 21.3163 17.8896 22 16.7166 22H4C2.89543 22 2 21.1046 2 20V10C2 8.89543 2.89543 8 4 8H7.17139L12.4415 2.72991C12.9088 2.26256 13.5427 2 14.2036 2C16.0562 2 17.2611 3.94957 16.4326 5.60655ZM9 20V9L13.8557 4.14412C13.948 4.05184 14.0731 4 14.2036 4C14.5694 4 14.8073 4.38495 14.6438 4.71212L12.7235 8.55281C12.3911 9.21771 12.8746 10 13.618 10H20V14.018C20 14.1619 19.969 14.304 19.9091 14.4347L17.6257 19.4167C17.4628 19.7721 17.1076 20 16.7166 20H9ZM4 20V10H7V20H4Z", fill: color }));
};
exports.default = factorySvgIcon_1.default(SvgLike);
//# sourceMappingURL=SvgLike.js.map